// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3uKRM","question":"Question_question__3UsrA","description":"Question_description__e-1-L"};